import { styled, table } from '@project44-manifest/react-styles';

export const StyledTable = styled('table', table);
